import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
import { formatPipe } from './utils'

 const getDate = (date: string) => {
      if (date) {
        const [year, month, day] = date?.split("-")
        return `${month}/${day}/${year}`
      }
      return ""
  }

export const onCreateDiaryBookExcel = async ({
  startedDate,
  endDate,
  data,
  name,
  document,
  imageUrl
}) => {
  const workbook = new ExcelJS.Workbook()

  const sheet = workbook.addWorksheet('Libro_Diario')

  fetch(imageUrl).then(
    async (r) => {
      const value = await r.arrayBuffer()
      const image = workbook.addImage({
        buffer: value,
        extension: 'png',
      })

      if (imageUrl) {
        sheet.mergeCells("A1:C1")
      }
      sheet.mergeCells('B3:E3')
      sheet.mergeCells('B4:E4')
      sheet.mergeCells('B5:E5')
      sheet.mergeCells('B6:E6')
      // sheet.mergeCells('C5:D5')

      // sheet.getRow(6).height = 50
      if (imageUrl) {
        sheet.addImage(image, {tl: {row: 0, col: 0},  ext: {width: 500, height: 160}})
        sheet.getRow(1).height = 150

      }
      // sheet.getColumn(1).width = 360

      // sheet.mergeCells(5, 3, 7, 4)
      // sheet.mergeCells('C5:D5')
      // sheet.mergeCells('C5:C7')
      // sheet.mergeCells('D5:D7')

    
      sheet.getCell('C3').value = 'LIBRO DIARIO'
      sheet.getCell(
        'C4'
      ).value = `PERIODO FISCAL DESDE: ${startedDate} HASTA: ${endDate}`
    
      sheet.getCell('C5').value = name.toUpperCase()
      sheet.getCell('C6').value = `RIF: ${document}`
    
      sheet.getCell('C3').style.font = { bold: true }
      sheet.getCell('C3').style.alignment = { horizontal: 'center' }
      sheet.getCell('C4').style.font = { bold: true }
      sheet.getCell('C4').style.alignment = { horizontal: 'center' }
      sheet.getCell('C5').style.font = { bold: true }
      sheet.getCell('C5').style.alignment = { horizontal: 'center' }
      sheet.getCell('C6').style.font = { bold: true }
      sheet.getCell('C6').style.alignment = { horizontal: 'center' }
    
      sheet.getCell('H5').style = {
        alignment: { horizontal: 'center' },
        font: { bold: true },
      }
      sheet.getCell('H6').style = {
        alignment: { horizontal: 'center' },
        font: { bold: true },
      }

    
      //Inicio de Tabla
    
      //Columna de fecha
      sheet.getColumn(1).width = 20
      sheet.getRow(8).height = 30
      
    
      sheet.getCell('A8').value = 'Fecha'
      sheet.getCell('A8').style.font = { bold: true }
      sheet.getCell('A8').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
      }
      sheet.getCell('A8').style.border = {
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
        top: { style: 'medium' },
      }
      sheet.getCell('A8').style.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'd6dce4' },
      }
    
      //Columna de Monto
      sheet.getColumn(2).width = 20
      sheet.getCell('B8').value = 'Monto'
      sheet.getCell('B8').style.font = { bold: true }
      sheet.getCell('B8').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
      }
      sheet.getCell('B8').style.border = {
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
        top: { style: 'medium' },
      }
      sheet.getCell('B8').style.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'd6dce4' },
      }
    
      //Columna de Descripción
      sheet.getColumn(3).width = 30
      sheet.getCell('C8').value = 'Descripción'
      sheet.getCell('C8').style.font = { bold: true }
      sheet.getCell('C8').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
      }
      sheet.getCell('C8').style.border = {
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
        top: { style: 'medium' },
      }
      sheet.getCell('C8').style.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'd6dce4' },
      }
    
      //Columna de Tipo
      sheet.getColumn(4).width = 20
      sheet.getCell('D8').value = 'Tipo'
      sheet.getCell('D8').style.font = { bold: true }
      sheet.getCell('D8').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
      }
      sheet.getCell('D8').style.border = {
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
        top: { style: 'medium' },
      }
      sheet.getCell('D8').style.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'd6dce4' },
      }
    
      //Columna de código cuenta contable
      sheet.getColumn(5).width = 25
      sheet.getCell('E8').value = 'Código cuenta contable'
      sheet.getCell('E8').style.font = { bold: true }
      sheet.getCell('E8').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
      }
      sheet.getCell('E8').style.border = {
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
        top: { style: 'medium' },
      }
      sheet.getCell('E8').style.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'd6dce4' },
      }
    
      //Columna de cuenta contable
      sheet.getColumn(6).width = 30
      sheet.getCell('F8').value = 'Cuenta contable'
      sheet.getCell('F8').style.font = { bold: true }
      sheet.getCell('F8').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
      }
      sheet.getCell('F8').style.border = {
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
        top: { style: 'medium' },
      }
      sheet.getCell('F8').style.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'd6dce4' },
      }
    
      //   const rows = [
      // ['09/02/2023', 2000, 'Descripcion de prueba..', 'HABER', 22828, 'wuierui'],
      // ['09/02/2023', 2000, 'Descripcion de prueba..', 'HABER', 22828, 'wuierui'],
      // ['09/02/2023', 2000, 'Descripcion de prueba..', 'HABER', 22828, 'wuierui'],
      //   ]
      let columns = ['A', 'B', 'C', 'D', 'E', 'F']
    
      //Rows
      data.forEach((v, idx) => {
        let row = 8 + idx + 1
        v.forEach((x, index) => {
          sheet.getCell(`${columns[index]}${row}`).value = x
          sheet.getCell(`${columns[index]}${row}`).style.alignment = {
            horizontal: 'center',
            vertical: 'middle',
            wrapText: true,
          }
          sheet.getCell(`${columns[index]}${row}`).style.border = {
            bottom: { style: 'thin' },
            left: { style: 'thin' },
            right: { style: 'thin' },
            top: { style: 'thin' },
          }
          if (idx % 2 == 0) {
            sheet.getCell(`${columns[index]}${row}`).style.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'f3f2f3' },
            }
          }
        })
      })
    
      const buffer = await workbook.xlsx.writeBuffer()
    
      const blob = new Blob([buffer], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      })
    
      saveAs(blob, 'Libro_diario' + '.xlsx')
    }
  )
}


export const onCreateAnalysisBookExcel = async ({
  startedDate,
  endDate,
  data,
  name,
  document,
  imageUrl,
  accountName,
  accountCode,
  parentCode,
  parentName,
  parentBalance,
  parentBeforeBalance
}) => {
  const workbook = new ExcelJS.Workbook()

  const sheet = workbook.addWorksheet('Mayor_Analítico')

  fetch(imageUrl).then(
    async (r) => {
      const value = await r.arrayBuffer()
      const image = workbook.addImage({
        buffer: value,
        extension: 'png',
      })

      if (imageUrl) {
        sheet.mergeCells("A1:C1")
      }
      sheet.mergeCells('A3:D3')
      sheet.mergeCells('A4:D4')
      sheet.mergeCells('A5:D5')
      sheet.mergeCells('A6:D6')
      sheet.mergeCells('A7:D7')
      // sheet.mergeCells('B9:C9')
      // sheet.mergeCells('B10:C10')
      // sheet.mergeCells('B11:C11')


      // sheet.mergeCells('C5:D5')

      // sheet.getRow(6).height = 50
      if (imageUrl) {
        sheet.addImage(image, {tl: {row: 0, col: 0},  ext: {width: 500, height: 160}})
        sheet.getRow(1).height = 150
      }
      // sheet.getColumn(1).width = 360

      // sheet.mergeCells(5, 3, 7, 4)
      // sheet.mergeCells('C5:D5')
      // sheet.mergeCells('C5:C7')
      // sheet.mergeCells('D5:D7')

    
      sheet.getCell('C3').value = 'MAYOR ANALÍTICO'
      sheet.getCell('C4').value = accountName?.toUpperCase()

      sheet.getCell(
        'C5'
      ).value = `DESDE: ${startedDate} HASTA: ${endDate}`
    
      sheet.getCell('C6').value = name.toUpperCase()
      sheet.getCell('C7').value = `RIF: ${document}`
    
      sheet.getCell('C3').style.font = { bold: true }
      sheet.getCell('C3').style.alignment = { horizontal: 'center' }
      sheet.getCell('C4').style.font = { bold: true }
      sheet.getCell('C4').style.alignment = { horizontal: 'center' }
      sheet.getCell('C5').style.font = { bold: true }
      sheet.getCell('C5').style.alignment = { horizontal: 'center' }
      sheet.getCell('C6').style.font = { bold: true }
      sheet.getCell('C6').style.alignment = { horizontal: 'center' }
      sheet.getCell('C7').style.font = { bold: true }
      sheet.getCell('C7').style.alignment = { horizontal: 'center' }

    
      sheet.getCell('H5').style = {
        alignment: { horizontal: 'center' },
        font: { bold: true },
      }
      sheet.getCell('H6').style = {
        alignment: { horizontal: 'center' },
        font: { bold: true },
      }

    
      //Tabla 
      sheet.getCell('A9').value = 'Código'
      sheet.getCell('B9').value = 'Descripción de la cuenta'

      sheet.getCell('C9').value = 'Saldo anterior'
      sheet.getCell('D9').value = 'Saldo final'

      sheet.getCell('A10').value = parentCode
      sheet.getCell('B10').value = parentName


      sheet.getCell('A11').value = accountCode
      sheet.getCell('B11').value = accountName

      sheet.getCell('C12').value = parentBeforeBalance
      sheet.getCell('D12').value = parentBalance


      sheet.getRow(9).height = 50
      sheet.getRow(10).height = 50
      sheet.getRow(11).height = 50
      sheet.getRow(12).height = 50
      sheet.getRow(14).height = 30

      sheet.getCell('A9').style.border = {
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
        top: { style: 'medium' },
      }

      sheet.getCell('B9').style.border = {
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
        top: { style: 'medium' },
      }

      sheet.getCell('C9').style.border = {
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
        top: { style: 'medium' },
      }

      
      sheet.getCell('D9').style.border = {
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
        top: { style: 'medium' },
      }


      sheet.getCell('B10').style.border = {
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
        top: { style: 'medium' },
      }

      sheet.getCell('A10').style.border = {
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
        top: { style: 'medium' },
      }

      sheet.getCell('C10').style.border = {
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
        top: { style: 'medium' },
      }

      sheet.getCell('D10').style.border = {
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
        top: { style: 'medium' },
      }

      sheet.getCell('A11').style.border = {
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
        top: { style: 'medium' },
      }

      sheet.getCell('B11').style.border = {
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
        top: { style: 'medium' },
      }

      sheet.getCell('C11').style.border = {
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
        top: { style: 'medium' },
      }

      sheet.getCell('D11').style.border = {
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
        top: { style: 'medium' },
      }

      sheet.getCell('A12').style.border = {
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
        top: { style: 'medium' },
      }

      sheet.getCell('B12').style.border = {
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
        top: { style: 'medium' },
      }

      sheet.getCell('C12').style.border = {
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
        top: { style: 'medium' },
      }

      
      sheet.getCell('D12').style.border = {
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
        top: { style: 'medium' },
      }
      
      
      sheet.getCell("A11").style.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'f3f2f3' },
      }

      sheet.getCell("B11").style.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'f3f2f3' },
      }
      
      sheet.getCell("C11").style.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'f3f2f3' },
      }

      sheet.getCell("D11").style.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'f3f2f3' },
      }

      sheet.getCell('A9').style.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'd6dce4' },
      }

      sheet.getCell('B9').style.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'd6dce4' },
      }

      sheet.getCell('C9').style.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'd6dce4' },
      }

      sheet.getCell('D9').style.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'd6dce4' },
      }

      sheet.getCell('A9').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
        wrapText: true,
      }

      
      sheet.getCell('C9').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
        wrapText: true,
      }

        
      sheet.getCell('D9').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
        wrapText: true,
      }

      sheet.getCell('A10').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
        wrapText: true,
      }

      sheet.getCell('A11').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
        wrapText: true,
      }

      sheet.getCell('B9').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
        wrapText: true,
      }

      sheet.getCell('B10').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
        wrapText: true,
      }

      sheet.getCell('C10').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
        wrapText: true,
      }

      
      sheet.getCell('D10').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
        wrapText: true,
      }
      
      sheet.getCell('B11').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
        wrapText: true,
      }

      sheet.getCell('C11').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
        wrapText: true,
      }

      sheet.getCell('D11').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
        wrapText: true,
      }

      sheet.getCell('C12').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
        wrapText: true,
      }

      sheet.getCell('D12').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
        wrapText: true,
      }


      sheet.getColumn(2).width = 35
    
      //Columna de fecha
      sheet.getColumn(1).width = 20

      sheet.getCell('A14').value = 'Fecha'
      sheet.getCell('A14').style.font = { bold: true }
      sheet.getCell('A14').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
      }
      sheet.getCell('A14').style.border = {
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
        top: { style: 'medium' },
      }
      sheet.getCell('A14').style.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'd6dce4' },
      }

        //Columna de Tipo
        sheet.getColumn(4).width = 20
        sheet.getCell('B14').value = 'Tipo'
        sheet.getCell('B14').style.font = { bold: true }
        sheet.getCell('B14').style.alignment = {
          horizontal: 'center',
          vertical: 'middle',
        }
        sheet.getCell('B14').style.border = {
          bottom: { style: 'medium' },
          left: { style: 'medium' },
          right: { style: 'medium' },
          top: { style: 'medium' },
        }
        sheet.getCell('B14').style.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'd6dce4' },
        }

       //Columna de Descripción
       sheet.getColumn(3).width = 30
       sheet.getCell('C14').value = 'Descripción'
       sheet.getCell('C14').style.font = { bold: true }
       sheet.getCell('C14').style.alignment = {
         horizontal: 'center',
         vertical: 'middle',
       }
       sheet.getCell('C14').style.border = {
         bottom: { style: 'medium' },
         left: { style: 'medium' },
         right: { style: 'medium' },
         top: { style: 'medium' },
       }
       sheet.getCell('C14').style.fill = {
         type: 'pattern',
         pattern: 'solid',
         fgColor: { argb: 'd6dce4' },
       }
    
      //Columna de Monto
      sheet.getColumn(2).width = 20
      sheet.getCell('D14').value = 'Monto'
      sheet.getCell('D14').style.font = { bold: true }
      sheet.getCell('D14').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
      }
      sheet.getCell('D14').style.border = {
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
        top: { style: 'medium' },
      }
      sheet.getCell('D14').style.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'd6dce4' },
      }
    
      //Columna de código cuenta contable
      // sheet.getColumn(5).width = 25
      // sheet.getCell('E9').value = 'Código cuenta contable'
      // sheet.getCell('E9').style.font = { bold: true }
      // sheet.getCell('E9').style.alignment = {
      //   horizontal: 'center',
      //   vertical: 'middle',
      // }
      // sheet.getCell('E9').style.border = {
      //   bottom: { style: 'medium' },
      //   left: { style: 'medium' },
      //   right: { style: 'medium' },
      //   top: { style: 'medium' },
      // }
      // sheet.getCell('E9').style.fill = {
      //   type: 'pattern',
      //   pattern: 'solid',
      //   fgColor: { argb: 'd6dce4' },
      // }
    
      //Columna de cuenta contable
      // sheet.getColumn(6).width = 30
      // sheet.getCell('F9').value = 'Cuenta contable'
      // sheet.getCell('F9').style.font = { bold: true }
      // sheet.getCell('F9').style.alignment = {
      //   horizontal: 'center',
      //   vertical: 'middle',
      // }
      // sheet.getCell('F9').style.border = {
      //   bottom: { style: 'medium' },
      //   left: { style: 'medium' },
      //   right: { style: 'medium' },
      //   top: { style: 'medium' },
      // }
      // sheet.getCell('F9').style.fill = {
      //   type: 'pattern',
      //   pattern: 'solid',
      //   fgColor: { argb: 'd6dce4' },
      // }
    
      //   const rows = [
      // ['09/02/2023', 2000, 'Descripcion de prueba..', 'HABER', 22828, 'wuierui'],
      // ['09/02/2023', 2000, 'Descripcion de prueba..', 'HABER', 22828, 'wuierui'],
      // ['09/02/2023', 2000, 'Descripcion de prueba..', 'HABER', 22828, 'wuierui'],
      //   ]
      let columns = ['A', 'B', 'C', 'D', 'E', 'F']
    
      //Rows
      data.forEach((v, idx) => {
        let row = 14 + idx + 1
        v.forEach((x, index) => {
          sheet.getCell(`${columns[index]}${row}`).value = x
          sheet.getCell(`${columns[index]}${row}`).style.alignment = {
            horizontal: 'center',
            vertical: 'middle',
            wrapText: true,
          }
          sheet.getCell(`${columns[index]}${row}`).style.border = {
            bottom: { style: 'thin' },
            left: { style: 'thin' },
            right: { style: 'thin' },
            top: { style: 'thin' },
          }
          if (idx % 2 == 0) {
            sheet.getCell(`${columns[index]}${row}`).style.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'f3f2f3' },
            }
          }
        })
      })
    
      const buffer = await workbook.xlsx.writeBuffer()
    
      const blob = new Blob([buffer], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      })
    
      saveAs(blob, 'Mayor_Analítico' + '.xlsx')
    }
  )
}

export const onCreateBalanceSheetExcel = async ({
  date,
  data,
  imageUrl
}) => {
  const workbook = new ExcelJS.Workbook()

  const sheet = workbook.addWorksheet('Estado_situacion_financiera')

  fetch(imageUrl).then(
    async (r) => {
      const value = await r.arrayBuffer()
      const image = workbook.addImage({
        buffer: value,
        extension: 'png',
      })

      if (imageUrl) {
        sheet.mergeCells("A1:C1")
      }
      sheet.mergeCells('B3:E3')
      sheet.mergeCells('B4:E4')
      sheet.mergeCells('B5:E5')

      if (imageUrl) {
        sheet.addImage(image, {tl: {row: 0, col: 0},  ext: {width: 500, height: 160}})
        sheet.getRow(1).height = 150
      }

      sheet.getCell('C3').value = 'Estado de Situación Financiera'

      sheet.getCell(
        'C4'
      ).value = `FECHA: ${date}`
        
      sheet.getCell('C3').style.font = { bold: true }
      sheet.getCell('C3').style.alignment = { horizontal: 'center' }
      sheet.getCell('C4').style.font = { bold: true }
      sheet.getCell('C4').style.alignment = { horizontal: 'center' }
    
      //Columna de Tipo
      sheet.getColumn(2).width = 30
      sheet.getCell('B6').value = 'Código'
      sheet.getCell('B6').style.font = { bold: true }
      sheet.getCell('B6').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
      }
      sheet.getCell('B6').style.border = {
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
        top: { style: 'medium' },
      }
      sheet.getCell('B6').style.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'd6dce4' },
      }
    
      //Columna de código cuenta contable
      sheet.getColumn(3).width = 50
      sheet.getCell('C6').value = 'Descripción'
      sheet.getCell('C6').style.font = { bold: true }
      sheet.getCell('C6').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
      }
      sheet.getCell('C6').style.border = {
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
        top: { style: 'medium' },
      }
      sheet.getCell('C6').style.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'd6dce4' },
      }
    
      //Columna de cuenta contable
      sheet.getColumn(4).width = 25
      sheet.getCell('D6').value = 'Monto'
      sheet.getCell('D6').style.font = { bold: true }
      sheet.getCell('D6').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
      }
      sheet.getCell('D6').style.border = {
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
        top: { style: 'medium' },
      }
      sheet.getCell('D6').style.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'd6dce4' },
      }
    
      let columns = ['B', 'C', 'D']
    
      //Rows
      data.forEach((v, idx) => {
        let row = 6 + idx + 1
        v.forEach((x, index) => {
          sheet.getCell(`${columns[index]}${row}`).value = x
          sheet.getCell(`${columns[index]}${row}`).style.alignment = {
            horizontal: 'center',
            vertical: 'middle',
            wrapText: true,
          }
          sheet.getCell(`${columns[index]}${row}`).style.border = {
            bottom: { style: 'thin' },
            left: { style: 'thin' },
            right: { style: 'thin' },
            top: { style: 'thin' },
          }
          if (idx % 2 == 0) {
            sheet.getCell(`${columns[index]}${row}`).style.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'f3f2f3' },
            }
          }
        })
      })
    
      const buffer = await workbook.xlsx.writeBuffer()
    
      const blob = new Blob([buffer], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      })
    
      saveAs(blob, 'Estado_situacion_financiera' + '.xlsx')
    }
  )
}

export const onCreateCashFlowExcel = async ({
  date,
  data,
  imageUrl
}) => {
  const workbook = new ExcelJS.Workbook()

  const sheet = workbook.addWorksheet('Flujo_efectivo')

  fetch(imageUrl).then(
    async (r) => {
      const value = await r.arrayBuffer()
      const image = workbook.addImage({
        buffer: value,
        extension: 'png',
      })

      if (imageUrl) {
        sheet.mergeCells("A1:C1")
      }
      sheet.mergeCells('B3:E3')
      sheet.mergeCells('B4:E4')
      sheet.mergeCells('B5:E5')

      if (imageUrl) {
        sheet.addImage(image, {tl: {row: 0, col: 0},  ext: {width: 500, height: 160}})
        sheet.getRow(1).height = 150
      }

      sheet.getCell('C3').value = 'Estado de Flujo de Efectivo'

      sheet.getCell(
        'C4'
      ).value = `PERIODO: ${date}`
        
      sheet.getCell('C3').style.font = { bold: true }
      sheet.getCell('C3').style.alignment = { horizontal: 'center' }
      sheet.getCell('C4').style.font = { bold: true }
      sheet.getCell('C4').style.alignment = { horizontal: 'center' }
      
      sheet.mergeCells('B6:F6')
      sheet.mergeCells('B7:F7')
      sheet.mergeCells('B8:F8')
      sheet.mergeCells('B9:F9')
      sheet.mergeCells('B10:F10')
      sheet.mergeCells('B11:F11')
      sheet.mergeCells('B12:F12')
      sheet.mergeCells('B13:F13')
      
      sheet.getCell('B6').style.alignment = {
        vertical: 'middle',
      }

      sheet.getCell('B7').style.alignment = {
        vertical: 'middle',
      }

      sheet.getCell('B8').style.alignment = {
        vertical: 'middle',
      }

      sheet.getCell('B9').style.alignment = {
        vertical: 'middle',
      }

      sheet.getCell('B10').style.alignment = {
        vertical: 'middle',
      }

      sheet.getCell('B11').style.alignment = {
        vertical: 'middle',
      }

      sheet.getRow(6).height = 20
      sheet.getRow(7).height = 20
      sheet.getRow(8).height = 20
      sheet.getRow(9).height = 20
      sheet.getRow(10).height = 20
      sheet.getRow(11).height = 20

      sheet.getCell('B6').value = 'Flujo del efectivo de actividades de operación'
      sheet.getCell('B6').style.font = { bold: true }

      sheet.getCell('B7').value = 'Cobros recibidos a los clientes'
      sheet.getCell('B8').value = 'Otros ingresos'
      sheet.getCell('B9').value = 'Pago de proveedores'
      sheet.getCell('B10').value = 'Pago de empleados'
      sheet.getCell('B11').value = 'Pago de impuestos'
      sheet.getCell('B12').value = 'Pago de gastos operativos'
      sheet.getCell('B13').value = 'Pago de intereses'
      sheet.getCell('B14').value = 'Otros egresos'
      sheet.getCell('B15').value = 'Efectivo neto provisto por las act. operación'

      sheet.getCell('G7').value = `${formatPipe(data?.cobroClientes, false, 2, -99999999999999)}`
      sheet.getCell('G8').value = `${formatPipe(data?.otrosIngresos, false, 2, -99999999999999)}`
      sheet.getCell('G9').value = `${formatPipe(data?.pagoProveedores, false, 2, -999999999999)}`
      sheet.getCell('G10').value = `${formatPipe(data?.pagoEmpleados, false, 2, -999999999999)}`
      sheet.getCell('G11').value = `${formatPipe(data?.pagoImpuestos, false, 2, -99999999999)}`
      sheet.getCell('G12').value = `${formatPipe(data?.pagoGastosOperativos, false, 2, -999999999)}`
      sheet.getCell('G13').value = `${formatPipe(data?.pagoIntereses, false, 2, -9999999999)}`

      sheet.getCell('G15').value = `${formatPipe(data?.netCashOperacion, false, 2, -999999999999)}`

      sheet.getCell('G7').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
      }
      sheet.getCell('G8').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
      }
      sheet.getCell('G9').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
      }
      sheet.getCell('G10').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
      }
      sheet.getCell('G11').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
      }
      sheet.getCell('G12').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
      }
      sheet.getCell('G13').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
      }

      sheet.getCell('G15').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
      }

      console.log("VER", data)

      const objTransform = {
        cobroClientesFlows: 'Flujo de cobro de clientes',
        otrosIngresosFlows: 'Flujo de otros ingresos',
        pagoProveedoresFlows: 'Flujo de pago de proveedores',
        pagoImpuestosFlows: 'Flujo de pago de impuestos',
        pagoGastosOperativosFlows: 'Flujo de gastos operativos',
        pagoInteresesFlows: 'Flujo de pago de intereses',
        compraEquiposFlows: 'Flujo de compra de equipos',
        ventaEquiposFlows: 'Flujo de venta de equipos',
        compraInmueblesFlows: 'Flujo de compra de inmuebles',
        ingresosCreditosFlows: 'Flujo de crédito de ingresos',
        pagoCreditosFlows: 'Flujo de pago de créditos',
        ingresosCapitalFlows: 'Flujo de ingresos de capital',
        pagoDividendosFlows: 'Flujo de pago de dividendos',
        otrosEgresosFlows: 'Flujo de otros egresos'
      }

      const getDataTable = (prop) => {

        if (data?.appendix[prop] && data.appendix[prop].length > 0) {

        const sheetLocal = workbook.addWorksheet(objTransform[prop])

        let row = 1

        sheetLocal.getColumn(`A`).width = 25
        sheetLocal.getColumn(`B`).width = 25
        sheetLocal.getColumn(`C`).width = 25
        sheetLocal.getColumn(`D`).width = 25

        sheetLocal.getRow(1).height = 30

        sheetLocal.getCell(`A${row}`).value = 'Fecha'
        sheetLocal.getCell(`B${row}`).value = 'Tipo'
        sheetLocal.getCell(`C${row}`).value = 'Monto'
        sheetLocal.getCell(`D${row}`).value = 'Descripción'

         sheetLocal.getCell(`A${row}`).style.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'd6dce4' },
      }

         sheetLocal.getCell(`B${row}`).style.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'd6dce4' },
      }


         sheetLocal.getCell(`C${row}`).style.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'd6dce4' },
      }


         sheetLocal.getCell(`D${row}`).style.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'd6dce4' },
      }


      
        sheetLocal.getCell(`A${row}`).style.alignment = {
          horizontal: 'center',
          vertical: 'middle',
          wrapText: true,
        }
        sheetLocal.getCell(`A${row}`).style.border = {
          bottom: { style: 'thin' },
          left: { style: 'thin' },
          right: { style: 'thin' },
          top: { style: 'thin' },
        }

        sheetLocal.getCell(`B${row}`).style.alignment = {
          horizontal: 'center',
          vertical: 'middle',
          wrapText: true,
        }
        sheetLocal.getCell(`B${row}`).style.border = {
          bottom: { style: 'thin' },
          left: { style: 'thin' },
          right: { style: 'thin' },
          top: { style: 'thin' },
        }


        sheetLocal.getCell(`C${row}`).style.alignment = {
          horizontal: 'center',
          vertical: 'middle',
          wrapText: true,
        }
        sheetLocal.getCell(`C${row}`).style.border = {
          bottom: { style: 'thin' },
          left: { style: 'thin' },
          right: { style: 'thin' },
          top: { style: 'thin' },
        }


        sheetLocal.getCell(`D${row}`).style.alignment = {
          horizontal: 'center',
          vertical: 'middle',
          wrapText: true,
        }
        sheetLocal.getCell(`D${row}`).style.border = {
          bottom: { style: 'thin' },
          left: { style: 'thin' },
          right: { style: 'thin' },
          top: { style: 'thin' },
        }


        data.appendix[prop].forEach((v, idx) => {
          let row = 1 + idx + 1
  
            sheetLocal.getCell(`A${row}`).value = getDate(v?.date)
            sheetLocal.getCell(`B${row}`).value = v?.type
            sheetLocal.getCell(`C${row}`).value = formatPipe(v?.bsAmount ? v?.bsAmount : v?.usdAmount, false, 2, -999999999999)
            sheetLocal.getCell(`D${row}`).value = v?.description

            sheetLocal.getCell(`A${row}`).style.alignment = {
              horizontal: 'center',
              vertical: 'middle',
              wrapText: true,
            }

            sheetLocal.getCell(`B${row}`).style.alignment = {
              horizontal: 'center',
              vertical: 'middle',
              wrapText: true,
            }

            sheetLocal.getCell(`C${row}`).style.alignment = {
              horizontal: 'center',
              vertical: 'middle',
              wrapText: true,
            }

            sheetLocal.getCell(`D${row}`).style.alignment = {
              horizontal: 'center',
              vertical: 'middle',
              wrapText: true,
            }

            sheetLocal.getCell(`A${row}`).style.border = {
              bottom: { style: 'thin' },
              left: { style: 'thin' },
              right: { style: 'thin' },
              top: { style: 'thin' },
            }

            sheetLocal.getCell(`B${row}`).style.border = {
              bottom: { style: 'thin' },
              left: { style: 'thin' },
              right: { style: 'thin' },
              top: { style: 'thin' },
            }

            sheetLocal.getCell(`C${row}`).style.border = {
              bottom: { style: 'thin' },
              left: { style: 'thin' },
              right: { style: 'thin' },
              top: { style: 'thin' },
            }

            sheetLocal.getCell(`D${row}`).style.border = {
              bottom: { style: 'thin' },
              left: { style: 'thin' },
              right: { style: 'thin' },
              top: { style: 'thin' },
            }

            if (row % 2 == 0) {
              sheetLocal.getCell(`A${row}`).style.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'f3f2f3' },
              }

              sheetLocal.getCell(`B${row}`).style.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'f3f2f3' },
              }

              sheetLocal.getCell(`C${row}`).style.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'f3f2f3' },
              }

              sheetLocal.getCell(`D${row}`).style.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'f3f2f3' },
              }

            }

        })
      }
      }

      getDataTable('cobroClientesFlows')
      getDataTable('otrosIngresosFlows')
      getDataTable('pagoProveedoresFlows')
      getDataTable('pagoEmpleadosFlows')
      getDataTable('pagoImpuestosFlows')
      getDataTable('pagoGastosOperativosFlows')
            getDataTable('pagoInteresesFlows')
      getDataTable('compraEquiposFlows')
            getDataTable('ventaEquiposFlows')
      getDataTable('compraInmueblesFlows')
      getDataTable('ingresosCreditosFlows')
      getDataTable('pagoCreditosFlows')
      getDataTable('ingresosCapitalFlows')
      getDataTable('pagoDividendosFlows')
      getDataTable('otrosEgresosFlows')

         
      const buffer = await workbook.xlsx.writeBuffer()
    
      const blob = new Blob([buffer], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      })
    
      saveAs(blob, 'Flujo_efectivo' + '.xlsx')
    }
  )
}

export const onCreateEstadoResultado = async ({
  date,
  data,
  imageUrl
}) => {
  const workbook = new ExcelJS.Workbook()

  const sheet = workbook.addWorksheet('Estado_situacion_financiera')

  fetch(imageUrl).then(
    async (r) => {
      const value = await r.arrayBuffer()
      const image = workbook.addImage({
        buffer: value,
        extension: 'png',
      })

      if (imageUrl) {
        sheet.mergeCells("A1:C1")
      }
      sheet.mergeCells('B3:E3')
      sheet.mergeCells('B4:E4')
      sheet.mergeCells('B5:E5')

      if (imageUrl) {
        sheet.addImage(image, {tl: {row: 0, col: 0},  ext: {width: 500, height: 160}})
        sheet.getRow(1).height = 150
      }

      sheet.getCell('C3').value = 'Estado de Situación Financiera'

      sheet.getCell(
        'C4'
      ).value = `FECHA: ${date}`

      sheet.getCell('C3').style.font = { bold: true }
      sheet.getCell('C3').style.alignment = { horizontal: 'center' }
      sheet.getCell('C4').style.font = { bold: true }
      sheet.getCell('C4').style.alignment = { horizontal: 'center' }

      //Columna de Tipo
      sheet.getColumn(2).width = 30
      sheet.getCell('B6').value = 'Código'
      sheet.getCell('B6').style.font = { bold: true }
      sheet.getCell('B6').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
      }
      sheet.getCell('B6').style.border = {
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
        top: { style: 'medium' },
      }
      sheet.getCell('B6').style.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'd6dce4' },
      }

      //Columna de código cuenta contable
      sheet.getColumn(3).width = 50
      sheet.getCell('C6').value = 'Descripción'
      sheet.getCell('C6').style.font = { bold: true }
      sheet.getCell('C6').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
      }
      sheet.getCell('C6').style.border = {
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
        top: { style: 'medium' },
      }
      sheet.getCell('C6').style.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'd6dce4' },
      }

      //Columna de cuenta contable
      sheet.getColumn(4).width = 25
      sheet.getCell('D6').value = 'Monto'
      sheet.getCell('D6').style.font = { bold: true }
      sheet.getCell('D6').style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
      }
      sheet.getCell('D6').style.border = {
        bottom: { style: 'medium' },
        left: { style: 'medium' },
        right: { style: 'medium' },
        top: { style: 'medium' },
      }
      sheet.getCell('D6').style.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'd6dce4' },
      }

      let columns = ['B', 'C', 'D']

      //Rows
      data.forEach((v, idx) => {
        let row = 6 + idx + 1
        v.forEach((x, index) => {
          sheet.getCell(`${columns[index]}${row}`).value = x
          sheet.getCell(`${columns[index]}${row}`).style.alignment = {
            horizontal: 'center',
            vertical: 'middle',
            wrapText: true,
          }
          sheet.getCell(`${columns[index]}${row}`).style.border = {
            bottom: { style: 'thin' },
            left: { style: 'thin' },
            right: { style: 'thin' },
            top: { style: 'thin' },
          }
          if (idx % 2 == 0) {
            sheet.getCell(`${columns[index]}${row}`).style.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'f3f2f3' },
            }
          }
        })
      })

      const buffer = await workbook.xlsx.writeBuffer()

      const blob = new Blob([buffer], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      })

      saveAs(blob, 'Estado_Resultados' + '.xlsx')
    }
  )
}

export const onCreateSubscribersExcel = async ({
  data
}) => {
  const workbook = new ExcelJS.Workbook()

  const sheet = workbook.addWorksheet('Suscriptores')

  // Título
  sheet.mergeCells('A1:G1')
  sheet.getCell('A1').value = 'REPORTE DE SUSCRIPTORES'
  sheet.getCell('A1').style.font = { bold: true, size: 16 }
  sheet.getCell('A1').style.alignment = { horizontal: 'center', vertical: 'middle' }
  sheet.getRow(1).height = 30

  // Headers de la tabla
  sheet.getRow(3).height = 30

  // Columna Nombre
  sheet.getColumn(1).width = 30
  sheet.getCell('A3').value = 'Nombre'
  sheet.getCell('A3').style.font = { bold: true }
  sheet.getCell('A3').style.alignment = {
    horizontal: 'center',
    vertical: 'middle',
  }
  sheet.getCell('A3').style.border = {
    bottom: { style: 'medium' },
    left: { style: 'medium' },
    right: { style: 'medium' },
    top: { style: 'medium' },
  }
  sheet.getCell('A3').style.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'd6dce4' },
  }

  // Columna Documento
  sheet.getColumn(2).width = 25
  sheet.getCell('B3').value = 'Documento'
  sheet.getCell('B3').style.font = { bold: true }
  sheet.getCell('B3').style.alignment = {
    horizontal: 'center',
    vertical: 'middle',
  }
  sheet.getCell('B3').style.border = {
    bottom: { style: 'medium' },
    left: { style: 'medium' },
    right: { style: 'medium' },
    top: { style: 'medium' },
  }
  sheet.getCell('B3').style.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'd6dce4' },
  }

  // Columna Descripción de la suscripción
  sheet.getColumn(3).width = 35
  sheet.getCell('C3').value = 'Descripción de la suscripción'
  sheet.getCell('C3').style.font = { bold: true }
  sheet.getCell('C3').style.alignment = {
    horizontal: 'center',
    vertical: 'middle',
  }
  sheet.getCell('C3').style.border = {
    bottom: { style: 'medium' },
    left: { style: 'medium' },
    right: { style: 'medium' },
    top: { style: 'medium' },
  }
  sheet.getCell('C3').style.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'd6dce4' },
  }

  // Columna Fecha de inicio
  sheet.getColumn(4).width = 25
  sheet.getCell('D3').value = 'Fecha de inicio'
  sheet.getCell('D3').style.font = { bold: true }
  sheet.getCell('D3').style.alignment = {
    horizontal: 'center',
    vertical: 'middle',
  }
  sheet.getCell('D3').style.border = {
    bottom: { style: 'medium' },
    left: { style: 'medium' },
    right: { style: 'medium' },
    top: { style: 'medium' },
  }
  sheet.getCell('D3').style.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'd6dce4' },
  }

  // Columna Fecha fin
  sheet.getColumn(5).width = 25
  sheet.getCell('E3').value = 'Fecha fin'
  sheet.getCell('E3').style.font = { bold: true }
  sheet.getCell('E3').style.alignment = {
    horizontal: 'center',
    vertical: 'middle',
  }
  sheet.getCell('E3').style.border = {
    bottom: { style: 'medium' },
    left: { style: 'medium' },
    right: { style: 'medium' },
    top: { style: 'medium' },
  }
  sheet.getCell('E3').style.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'd6dce4' },
  }

  // Columna Email
  sheet.getColumn(6).width = 30
  sheet.getCell('F3').value = 'Email'
  sheet.getCell('F3').style.font = { bold: true }
  sheet.getCell('F3').style.alignment = {
    horizontal: 'center',
    vertical: 'middle',
  }
  sheet.getCell('F3').style.border = {
    bottom: { style: 'medium' },
    left: { style: 'medium' },
    right: { style: 'medium' },
    top: { style: 'medium' },
  }
  sheet.getCell('F3').style.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'd6dce4' },
  }

  // Columna Teléfono
  sheet.getColumn(7).width = 20
  sheet.getCell('G3').value = 'Teléfono'
  sheet.getCell('G3').style.font = { bold: true }
  sheet.getCell('G3').style.alignment = {
    horizontal: 'center',
    vertical: 'middle',
  }
  sheet.getCell('G3').style.border = {
    bottom: { style: 'medium' },
    left: { style: 'medium' },
    right: { style: 'medium' },
    top: { style: 'medium' },
  }
  sheet.getCell('G3').style.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'd6dce4' },
  }

  const columns = ['A', 'B', 'C', 'D', 'E', 'F', 'G']

  // Rows
  data.forEach((row, idx) => {
    const rowNumber = 3 + idx + 1
    row.forEach((cellValue, index) => {
      sheet.getCell(`${columns[index]}${rowNumber}`).value = cellValue
      sheet.getCell(`${columns[index]}${rowNumber}`).style.alignment = {
        horizontal: 'center',
        vertical: 'middle',
        wrapText: true,
      }
      sheet.getCell(`${columns[index]}${rowNumber}`).style.border = {
        bottom: { style: 'thin' },
        left: { style: 'thin' },
        right: { style: 'thin' },
        top: { style: 'thin' },
      }
      if (idx % 2 === 0) {
        sheet.getCell(`${columns[index]}${rowNumber}`).style.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'f3f2f3' },
        }
      }
    })
  })

  const buffer = await workbook.xlsx.writeBuffer()

  const blob = new Blob([buffer], {
    type:
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
  })

  saveAs(blob, 'Suscriptores.xlsx')
}